import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom'
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
//Login folder Steps
import '../../axios.setup';

import Login from "../Login/Login"

// Loading page
import LoadingPage from "../LoadingPage/LoadingPage"

// Include page
import SideBar from '../Includes/Sidebar'

// welcome page
import WelcomePage from '../WelcomePage/WelcomePage'

// Settings Page
import SettingsPage from '../SettingsPage/SettingsPage'

// Settings Page
import UploadPage from '../RecentUploads/UploadPage'
import ReportPdf from '../ReportPDF/ReportPdf'

//Timeline
import Timeline from '../Analysis/Timeline/Timeline'


const NotFoundRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear local storage when user hits an unknown route
    localStorage.clear();

    // Redirect to login page
    navigate('/', { replace: true });
  }, [navigate]);

  return null; // No UI needed
};


const Router = () => {
  return (
    <>

      {/* <BrowserRouter basename='/'> */}

      {/* for server */}
      <BrowserRouter>
        {/* <PayPalScriptProvider options={{
          clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
          currency: process.env.REACT_APP_PAYPAL_CURRENCY,
          components: "buttons"
        }}> */}
        <Routes>
          <Route path='/' element={<Login />} />

          {/* Include page */}
          <Route path='/sidebar' element={<SideBar />} />

          {/* Welcome page */}
          <Route path='/welcome' element={<WelcomePage />} />

          {/* Settings Page */}
          <Route path='/settings' element={<SettingsPage />} />


          {/* Settings Page */}
          <Route path='/uploads' element={<UploadPage />} />
          <Route path='/test' element={<ReportPdf />} />
          <Route path='/timeline' element={<Timeline />} />
          <Route path="*" element={<NotFoundRedirect />} />
        </Routes>
        {/* </PayPalScriptProvider> */}
      </BrowserRouter>

    </>
  )
}

export default Router